var InfoPopupComponent = (function () {
    function InfoPopupComponent() {
        this.isOpen = false;
    }
    InfoPopupComponent.prototype.ngOnInit = function () { };
    InfoPopupComponent.prototype.show = function () {
        this.isOpen = true;
    };
    InfoPopupComponent.prototype.close = function () {
        this.isOpen = false;
    };
    return InfoPopupComponent;
}());
export { InfoPopupComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/info-popup/info-popup.component.ts.pre-build-optimizer.js